import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'lodash';

import RateEditFlyoverUI from '../RateEditFlyoverUI';

const ExpenseRateContainer = ({ rate, defaultCurrency, type, onChange }) => {
  const handleRateChange = useCallback(
    (val, key) => {
      const value = {
        ...rate,
        ...val,
        interval: val.interval || 'DAILY',
        quantity: !isNil(val.quantity) ? val.quantity : ''
      };

      if (value.slotCategoryId) {
        const payload = {
          commit_rate_amount: value.amount,
          commit_rate_interval: value.interval,
          commit_rate_quantity: Number(value.quantity) ? value.quantity : null,
          commit_rate_currency: value.currency
        };

        onChange?.(value.id, payload);
      }
    },
    [rate, onChange]
  );

  return (
    <RateEditFlyoverUI
      rate={rate}
      defaultCurrency={defaultCurrency}
      type={type}
      onRateChange={handleRateChange}
    />
  );
};

ExpenseRateContainer.propTypes = {
  rate: PropTypes.object,
  defaultCurrency: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func
};

export default ExpenseRateContainer;
